import React, {useEffect} from 'react';
import {useForm} from "react-hook-form";
import {useDispatch} from "react-redux";

import css from './SearchInputComponentModal.module.css';
import {dishesActions} from "../../../../store/slices/dishes-slices";


const SearchInputComponentModal = () => {
    const dispatch = useDispatch();
    const {register, handleSubmit, setValue} = useForm();

    // Clear search on component unmount
    useEffect(() => {
        return () => {
            dispatch(dishesActions.clearSearch());
        };
    }, [dispatch]);

    const handleOnSubmit = (data) => {
        dispatch(dishesActions.filteredDishes(data.searchInput));
    }

    const handleClearSearch = () => {
        setValue('searchInput', '');
        dispatch(dishesActions.clearSearch());
    }


    return (
        <div className={css.wrap}>
            <form onChange={handleSubmit(handleOnSubmit)}>
                <input
                    type="text"
                    {...register('searchInput')}
                    placeholder="Search"
                    className={css.searchInput}
                />
                <button 
                    type="button" 
                    onClick={handleClearSearch}
                    className={css.clearButton}
                >
                    Clear
                </button>
            </form>
        </div>
    );
};

export {SearchInputComponentModal};